import Vue from 'vue';

import { localize } from './localize';
import { customTerm } from './customTerm';

Vue.filter('localize', localize);
Vue.filter('customTerm', customTerm);
